import script from "./Dropzone.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dropzone.vue?vue&type=script&lang=ts&setup=true"

import "./Dropzone.vue?vue&type=style&index=0&id=752e6004&lang=css"

const __exports__ = script;

export default __exports__